import React, { useCallback } from "react";
import { RESPONSIBLE_QUERY } from "../queries";
import { Autocomplete } from "@totalsoft/rocket-webapp-components-deprecated";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { emptyArray, emptyString } from "constants/defaultValues";
import PropTypes from "prop-types";

function ChangeResponsibleContent({ dialogState, setDialogState }) {
  const { t } = useTranslation();
  const { data } = useQueryWithErrorHandling(RESPONSIBLE_QUERY);

  const handleChange = useCallback(
    (value) => {
      setDialogState({ id: value });
    },
    [setDialogState]
  );

  return (
    <>
      <Typography gutterBottom>{t("Quote.ChangeResponsibleMessage")}</Typography>
      <Autocomplete
        id="responsibleIdChange"
        value={dialogState.id || emptyString}
        label={t("Quote.Responsible")}
        simpleValue={true}
        options={data?.responsibleList || emptyArray}
        valueKey="id"
        labelKey="name"
        onChange={handleChange}
        isClearable={true}
        noOptionsText={t("General.AutocompleteNoOptions")}
      />
    </>
  );
}

ChangeResponsibleContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
  setDialogState: PropTypes.func.isRequired,
};

export default ChangeResponsibleContent;
